const config = {
  API_KEY: '88f9ceaa747bb732170f6e5bcd309781'
}
export default config;



// WEBPACK FOOTER //
// ./src/config.js